/**
 * Featured Collection Tabs
 * Handles two-tier tab switching: meta-tabs and sub-tabs
 */

class CollectionTabs {
  constructor(container) {
    this.container = container;
    this.metaButtons = container.querySelectorAll('[data-meta-tab]');
    this.metaPanels = container.querySelectorAll('[data-meta-panel]');
    
    if (!this.metaButtons.length || !this.metaPanels.length) return;
    
    this.init();
  }
  
  init() {
    // Add click handlers to meta-level buttons
    this.metaButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchMetaTab(button);
      });
    });
    
    // Add click handlers to all sub-level tab buttons
    this.metaPanels.forEach(metaPanel => {
      const subButtons = metaPanel.querySelectorAll('[data-tab]');
      const subPanels = metaPanel.querySelectorAll('[data-panel]');
      
      subButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchSubTab(button, subButtons, subPanels);
        });
      });
    });
  }
  
  switchMetaTab(clickedButton) {
    const targetMetaTab = clickedButton.getAttribute('data-meta-tab');
    
    // Update meta button states
    this.metaButtons.forEach(button => {
      button.classList.remove('active');
    });
    clickedButton.classList.add('active');
    
    // Update meta panel visibility
    this.metaPanels.forEach(panel => {
      const panelMetaTab = panel.getAttribute('data-meta-panel');
      
      if (panelMetaTab === targetMetaTab) {
        panel.classList.add('active');
      } else {
        panel.classList.remove('active');
      }
    });
  }
  
  switchSubTab(clickedButton, buttons, panels) {
    const targetTab = clickedButton.getAttribute('data-tab');
    
    // Update sub button states
    buttons.forEach(button => {
      button.classList.remove('active');
    });
    clickedButton.classList.add('active');
    
    // Update sub panel visibility
    panels.forEach(panel => {
      const panelTab = panel.getAttribute('data-panel');
      
      if (panelTab === targetTab) {
        panel.classList.add('active');
      } else {
        panel.classList.remove('active');
      }
    });
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  const tabContainers = document.querySelectorAll('[data-collection-tabs]');
  tabContainers.forEach(container => {
    new CollectionTabs(container);
  });
});

// Re-initialize on Shopify section load (theme editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const tabContainers = event.target.querySelectorAll('[data-collection-tabs]');
    tabContainers.forEach(container => {
      new CollectionTabs(container);
    });
  });
}
